(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const menus = document.querySelectorAll('.header__menu-mobile');
    menus.forEach((menu) => {
      const toggle = menu.querySelector('.header__menu-toggle');
      if (!toggle) return;

      const sync = () => {
        const open = menu.open;
        toggle.classList.toggle('is-active', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      menu.addEventListener('toggle', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-main-product]');
    if (!root) return;

    const form = root.querySelector('[data-product-form]');
    const picker = root.querySelector('[data-bundle-picker]');
    const variantIdInput = root.querySelector('[data-variant-id]');
    const qtyInput = root.querySelector('[data-bundle-qty]');
    const propsHost = root.querySelector('[data-line-properties]');

    let productVariants = [];
    try {
      const variantsEl = root.querySelector('[data-product-variants]');
      if (variantsEl?.textContent) {
        productVariants = JSON.parse(variantsEl.textContent);
      }
    } catch {
      productVariants = [];
    }

    const syncVariantId = (variantId) => {
      if (!variantId) return;
      const id = String(variantId);
      if (variantIdInput) {
        variantIdInput.value = id;
        variantIdInput.disabled = false;
      }
      document.querySelectorAll('.sticky-atc__form input[name="id"], [data-sticky-variant-id]').forEach((input) => {
        input.value = id;
        input.disabled = false;
      });
    };

    const resolveVariantIdFromCard = (card) => {
      const radio = card?.querySelector('.bundle-card__radio');
      const fromRadio = radio?.getAttribute('data-variant-id') || radio?.dataset.variantId;
      if (fromRadio) return String(fromRadio);

      const qty = Number(radio?.dataset.qty || radio?.value || 1) || 1;
      const title = card?.querySelector('.bundle-card__title')?.textContent?.trim() || `Buy ${qty}`;
      const buyLabel = `Buy ${qty}`;
      const match = productVariants.find((v) => {
        const vTitle = String(v.title || '').trim();
        const vOpt = String(v.option1 || '').trim();
        return vTitle === title || vOpt === title || vTitle === buyLabel || vOpt === buyLabel;
      });
      if (match?.id) return String(match.id);

      if (picker && productVariants.length) {
        const cards = [...picker.querySelectorAll('[data-bundle-card]')];
        const index = cards.indexOf(card);
        if (index >= 0 && productVariants.length === cards.length && productVariants[index]?.id) {
          return String(productVariants[index].id);
        }
      }
      return '';
    };

    const syncQty = (qty) => {
      if (qtyInput) qtyInput.value = String(qty);
      document.querySelectorAll('[data-sticky-qty]').forEach((input) => {
        input.value = String(qty);
      });
    };

    const syncStickyPrice = (card) => {
      const priceText = card?.querySelector('.bundle-card__price')?.textContent?.trim();
      if (!priceText) return;
      document.querySelectorAll('[data-sticky-price]').forEach((el) => {
        el.textContent = priceText;
      });
    };

    const applyCard = (card) => {
      if (!picker || !card) return;
      const cards = [...picker.querySelectorAll('[data-bundle-card]')];
      cards.forEach((c) => {
        const selected = c === card;
        c.classList.toggle('is-selected', selected);
        const radio = c.querySelector('.bundle-card__radio');
        if (radio) radio.checked = selected;
      });

      const radio = card.querySelector('.bundle-card__radio');
      const bundleQty = Math.max(1, Number(radio?.dataset.qty || radio?.value || 1) || 1);
      const mappedVariantId = resolveVariantIdFromCard(card);
      if (mappedVariantId) {
        syncVariantId(mappedVariantId);
        if (radio && !radio.getAttribute('data-variant-id')) {
          radio.setAttribute('data-variant-id', mappedVariantId);
        }
        syncQty(1);
      } else {
        syncQty(bundleQty);
      }
      syncStickyPrice(card);
    };

    if (picker) {
      picker.addEventListener('change', (event) => {
        const radio = event.target.closest('.bundle-card__radio');
        if (!radio || !picker.contains(radio)) return;
        const card = radio.closest('[data-bundle-card]');
        if (card) applyCard(card);
      });

      picker.addEventListener('click', (event) => {
        const card = event.target.closest('[data-bundle-card]');
        if (!card || !picker.contains(card)) return;
        const radio = card.querySelector('.bundle-card__radio');
        if (!radio) return;
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          applyCard(card);
        }
      });

      const initial = picker.querySelector('.bundle-card__radio:checked')?.closest('[data-bundle-card]')
        || picker.querySelector('[data-bundle-card].is-selected')
        || picker.querySelector('[data-bundle-card]');
      applyCard(initial);
    }

    const cartRoot = () => (window.Shopify?.routes?.root ? window.Shopify.routes.root : '/');

    const isValidProtectionId = (value) => {
      const id = String(value || '').trim();
      if (!id) return false;
      const num = Number(id);
      return Number.isFinite(num) && num > 0 && String(Math.trunc(num)) === id;
    };

    const PROTECTION_OPT_OUT_KEY = 'capblast-shipping-protection-opt-out';

    const isProtectionOptedOut = () => {
      try {
        return sessionStorage.getItem(PROTECTION_OPT_OUT_KEY) === '1';
      } catch {
        return false;
      }
    };

    const isProtectionDefaultOn = () => {
      const host = document.querySelector('[data-shipping-protection-default]');
      if (host) return host.getAttribute('data-shipping-protection-default') !== 'false';
      return !!root.querySelector('[data-shipping-protection]');
    };

    const wantsProtection = () => {
      if (isProtectionOptedOut()) return false;
      if (isProtectionDefaultOn()) return true;
      return !!root.querySelector('[data-shipping-protection]:checked');
    };

    const getProtectionVariantId = () => {
      const host = root.querySelector('[data-shipping-protection-variant]');
      const fromHost = host?.getAttribute('data-shipping-protection-variant') || '';
      const fromDrawer =
        document.querySelector('[data-cart-drawer]')?.getAttribute('data-protection-variant-id') || '';
      const candidate = fromHost || fromDrawer || '';
      return isValidProtectionId(candidate) ? candidate : '';
    };

    const uncheckProtectionToggles = () => {
      document.querySelectorAll('[data-shipping-protection], [data-cart-shipping-protection]').forEach((el) => {
        el.checked = false;
      });
    };

    const checkProtectionToggles = () => {
      document.querySelectorAll('[data-shipping-protection], [data-cart-shipping-protection]').forEach((el) => {
        el.checked = true;
      });
    };

    const cartHasProtection = (cart, variantId) => {
      const id = String(variantId || '');
      return (cart.items || []).some((item) => {
        const props = item.properties || {};
        if (props._shipping_protection === '1') return true;
        return id && String(item.id) === id;
      });
    };

    const productPropsKey = (props) => {
      const bundle = String(props?.Bundle || '').replace(/\s+/g, ' ').trim();
      return bundle;
    };

    const findMatchingLine = (cart, item) => {
      const targetKey = productPropsKey(item.properties || {});
      return (cart.items || []).find((line) => {
        if (String(line.id) !== String(item.id)) return false;
        const lineProps = line.properties || {};
        if (lineProps._shipping_protection === '1') return false;
        return productPropsKey(lineProps) === targetKey;
      });
    };

    const buildItemsFromSelection = () => {
      let selected = picker
        ? picker.querySelector('[data-bundle-card].is-selected')
        : null;
      if (!selected && picker) {
        selected = picker.querySelector('.bundle-card__radio:checked')?.closest('[data-bundle-card]')
          || picker.querySelector('[data-bundle-card]');
        if (selected) applyCard(selected);
      }

      const protectionOn = wantsProtection();
      const radio = selected?.querySelector('.bundle-card__radio');
      const bundleQty = Math.max(
        1,
        Number(radio?.dataset.qty || radio?.value || qtyInput?.value || 1) || 1
      );
      const bundleLabel =
        selected?.querySelector('.bundle-card__title')?.textContent?.trim() || `Buy ${bundleQty}`;

      const mappedId = selected ? resolveVariantIdFromCard(selected) : '';
      const primaryVariantId = mappedId
        ? Number(mappedId) || null
        : (variantIdInput?.value ? Number(variantIdInput.value) || null : null);

      if (!primaryVariantId) {
        return { items: [], selected, selects: [], protectionOn, bundleLabel, volumesJoined: '' };
      }

      if (mappedId) syncVariantId(mappedId);

      const quantity = mappedId ? 1 : bundleQty;

      const items = [
        {
          id: primaryVariantId,
          quantity,
          properties: {
            Bundle: bundleLabel
          }
        }
      ];

      return { items, selected, selects: [], protectionOn, bundleLabel, volumesJoined: '', mappedId: !!mappedId };
    };

    const tryAddProtection = async (cart) => {
      if (!wantsProtection()) return false;
      const variantId = getProtectionVariantId();
      if (!variantId) return false;
      if (cart && cartHasProtection(cart, variantId)) {
        checkProtectionToggles();
        return true;
      }

      try {
        const addRes = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: { _shipping_protection: '1' }
              }
            ]
          })
        });
        if (!addRes.ok) {
          uncheckProtectionToggles();
          return false;
        }
        checkProtectionToggles();
        return true;
      } catch {
        uncheckProtectionToggles();
        return false;
      }
    };

    const addOrMergeProductItems = async (items) => {
      let cart = null;
      try {
        const cartRes = await fetch(`${cartRoot()}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (cartRes.ok) cart = await cartRes.json();
      } catch {
        cart = null;
      }

      const toAdd = [];
      for (const item of items) {
        const match = cart ? findMatchingLine(cart, item) : null;
        if (match) {
          const changeRes = await fetch(`${cartRoot()}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: match.key,
              quantity: Number(item.quantity || 1)
            })
          });
          if (!changeRes.ok) throw new Error('Cart change failed');
          cart = await changeRes.json();
        } else {
          toAdd.push(item);
        }
      }

      if (toAdd.length) {
        const addRes = await fetch(`${cartRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: toAdd })
        });
        if (!addRes.ok) throw new Error('Add to cart failed');
        cart = await addRes.json();
      }

      await tryAddProtection(cart);
      return cart;
    };

    const syncSelectedBundle = () => {
      if (!picker) return null;
      const selected =
        picker.querySelector('[data-bundle-card].is-selected')
        || picker.querySelector('.bundle-card__radio:checked')?.closest('[data-bundle-card]')
        || picker.querySelector('[data-bundle-card]');
      if (selected) applyCard(selected);
      return selected;
    };

    const parseMoneyToCents = (text) => {
      const cleaned = String(text || '').replace(/[^0-9.,]/g, '');
      if (!cleaned) return 0;
      const normalized = cleaned.includes(',') && !cleaned.includes('.')
        ? cleaned.replace(',', '.')
        : cleaned.replace(/,/g, '');
      const value = parseFloat(normalized);
      if (Number.isNaN(value)) return 0;
      return Math.round(value * 100);
    };

    const BUNDLE_PACK_CENTS = { 1: 2900, 2: 4800, 3: 6700 };

    const getBundlePackCents = (bundleQty, priceText) => {
      const qty = Math.max(1, Number(bundleQty) || 1);
      const fromLabel = parseMoneyToCents(priceText);
      if (fromLabel > 0) return fromLabel;
      return BUNDLE_PACK_CENTS[qty] || BUNDLE_PACK_CENTS[1];
    };

    const buildDemoCartPayload = () => {
      syncSelectedBundle();
      const selected =
        picker?.querySelector('[data-bundle-card].is-selected')
        || picker?.querySelector('.bundle-card__radio:checked')?.closest('[data-bundle-card]')
        || picker?.querySelector('[data-bundle-card]');

      const radio = selected?.querySelector('.bundle-card__radio');
      const bundleQty = Math.max(1, Number(radio?.dataset.qty || radio?.value || 1) || 1);
      const packCents = getBundlePackCents(
        bundleQty,
        selected?.querySelector('.bundle-card__price')?.textContent
      );
      const qty = bundleQty;
      const unitCents = Math.round(packCents / qty);
      const lineCents = packCents;
      const protectionOn = wantsProtection();
      const protectionCents = parseMoneyToCents(
        root.querySelector('.product-trust__protect-price')?.textContent
      ) || 299;
      const image =
        root.getAttribute('data-capblast-image')
        || root.querySelector('.product-hero__image')?.getAttribute('src')
        || root.querySelector('.product-hero__image')?.currentSrc
        || '';

      const items = [
        {
          key: 'demo-capblast-1',
          id: 'demo-capblast',
          product_title: 'The CapBlast',
          title: 'The CapBlast',
          variant_title: null,
          handle: 'the-capblast',
          quantity: qty,
          price: unitCents,
          line_price: lineCents,
          final_line_price: lineCents,
          image,
          url: '#product-hero',
          properties: {
            Bundle: `Buy ${qty}`
          }
        }
      ];

      if (protectionOn) {
        items.unshift({
          key: 'demo-shipping-protection',
          id: 'demo-shipping-protection',
          product_title: 'Shipping Protection',
          variant_title: null,
          handle: 'shipping-protection',
          quantity: 1,
          price: protectionCents,
          line_price: protectionCents,
          final_line_price: protectionCents,
          image: '',
          url: '#',
          properties: { _shipping_protection: '1' }
        });
      }

      const total_price = items.reduce((sum, item) => sum + (Number(item.final_line_price) || 0), 0);
      return {
        items,
        item_count: items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0),
        total_price,
        items_subtotal_price: total_price,
        demo: true
      };
    };

    const openDemoCart = async () => {
      const payload = buildDemoCartPayload();
      const openDrawer = async () => {
        if (!window.CartDrawer?.showDemo) return false;
        window.CartDrawer.showDemo(payload);
        window.CartDrawer.open();
        return true;
      };

      if (await openDrawer()) return true;

      await new Promise((resolve) => {
        const start = Date.now();
        const tick = () => {
          if (window.CartDrawer?.showDemo || Date.now() - start > 1500) {
            resolve();
            return;
          }
          requestAnimationFrame(tick);
        };
        tick();
      });

      return openDrawer();
    };

    const selectionHasValidVariants = () => {
      syncSelectedBundle();
      const built = buildItemsFromSelection();
      return built.items.length > 0 && built.items.every((item) => item.id);
    };

    const runAddToCart = async () => {
      syncSelectedBundle();

      if (root.hasAttribute('data-demo-mode') || !selectionHasValidVariants()) {
        await openDemoCart();
        return 'demo';
      }

      const built = buildItemsFromSelection();
      const items = built.items;
      if (!items.length) {
        await openDemoCart();
        return 'demo';
      }

      try {
        await addOrMergeProductItems(items);
        return 'live';
      } catch {
        await openDemoCart();
        return 'demo';
      }
    };

    window.CapBlastATC = {
      sync: syncSelectedBundle,
      build: () => {
        syncSelectedBundle();
        return buildItemsFromSelection();
      },
      add: async () => {
        const mode = await runAddToCart();
        return mode === 'live' || mode === 'demo' ? mode : false;
      },
      demo: openDemoCart
    };

    window.CartDrawer?.syncProductImage?.();

    const goToCart = () => {
      const routeRoot = window.Shopify?.routes?.root || '/';
      window.location.href = `${routeRoot}cart`;
    };

    const refreshAndOpenLiveCart = async () => {
      if (!window.CartDrawer) return false;
      try {
        await window.CartDrawer.refresh();
        window.CartDrawer.open();
      } catch {
        goToCart();
      }
      return true;
    };

    const bindAtcClick = (button) => {
      if (!button) return;
      button.addEventListener('click', async (event) => {
        if (button.disabled) return;
        if (form && !form.hasAttribute('data-demo-form') && button.getAttribute('type') === 'submit') {
          return;
        }
        event.preventDefault();
        button.disabled = true;
        window.__capblastAtcSource = 'main';
        window.__capblastSubmitting = true;
        let mode = false;
        try {
          mode = await runAddToCart();
        } catch {
          try {
            await openDemoCart();
          } catch {}
          mode = 'demo';
        }

        try {
          if (mode === 'live' && !(await refreshAndOpenLiveCart())) {
            goToCart();
          }
        } finally {
          button.disabled = false;
          window.__capblastSubmitting = false;
          window.__capblastAtcSource = '';
        }
      });
    };

    if (form) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const button = form.querySelector('[type="submit"], #MainProductAtc');
        if (button) button.disabled = true;
        window.__capblastAtcSource = 'main';
        window.__capblastSubmitting = true;

        let mode = false;
        try {
          mode = await runAddToCart();
        } catch {
          try {
            await openDemoCart();
          } catch {}
          mode = 'demo';
        }

        try {
          if (mode === 'live' && !(await refreshAndOpenLiveCart())) {
            await new Promise((resolve) => {
              const start = Date.now();
              const tick = () => {
                if (window.CartDrawer || Date.now() - start > 1500) {
                  resolve();
                  return;
                }
                requestAnimationFrame(tick);
              };
              tick();
            });
            if (!(await refreshAndOpenLiveCart())) {
              goToCart();
            }
          }
        } finally {
          if (button) button.disabled = false;
          window.__capblastSubmitting = false;
          window.__capblastAtcSource = '';
        }
      });
    }

    bindAtcClick(root.querySelector('[data-demo-atc], #MainProductAtc'));
  })();

  } catch(e) { console.error(e); }
})();
})();
